/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCustomerLimitsRequest} from '@cash-web/protos/squareup/cash/cashlimitsxp/api/v1/customer_limits.pb'
import {GetCustomerLimitsResponse} from '@cash-web/protos/squareup/cash/cashlimitsxp/api/v1/customer_limits.pb'


export const getCustomerLimits = (request: GetCustomerLimitsRequest, options?: CashRequestOptions) => post<GetCustomerLimitsRequest, GetCustomerLimitsResponse>("/cash-app/limits-xp/get-customer-limits", request, {...options, rejectOnError: true })